import React, { useCallback, useContext, useState } from 'react';

const DealTasksContext = React.createContext({});

export default function DealTasksProvider({ children }) {
  // Need to manage tasks count locally as we don't refresh the list when a task is completed or opened
  const [tasksCount, setTasksCounts] = useState([]);
  const [tasksCompleted, setTasksCompleted] = useState({});
  const [expanded, setExpanded] = useState({});

  const toggleExpanded = useCallback(id => {
    setExpanded(s => ({ ...s, [id]: !s[id] }));
  }, []);

  const setTaskCount = useCallback((index, count) => {
    setTasksCounts(c => {
      const cloned = { ...c };
      cloned[index] = count;
      return cloned;
    });
  }, []);

  const toggleTaskCompleted = useCallback(id => {
    setTasksCompleted(c => {
      const cloned = { ...c };
      cloned[id] = !cloned[id];
      return cloned;
    });
  }, []);

  return (
    <DealTasksContext.Provider
      value={{
        expanded,
        setTaskCount,
        tasksCompleted,
        tasksCount,
        toggleExpanded,
        toggleTaskCompleted
      }}
    >
      {React.Children.only(children)}
    </DealTasksContext.Provider>
  );
}

// HOOK
export const useDealTasks = () => useContext(DealTasksContext);
